<template>
    <div class="infoDiv">
        <Head></Head>
        <div class="info">
            <ul ref="infoUrl">
                <li>
                    <!-- <router-link to="/infoMember/info">个人基本信息</router-link> -->
                    <a href="javascript:;" @click="liType('info')" :class="{ active: type == 'info' }">个人基本信息</a>
                </li>
                <li v-if="$store.state.sgztData">
                    <!-- <router-link to="/infoMember/funeral">去世安葬信息</router-link> -->
                    <a href="javascript:;" @click="liType('funeral')" :class="{ active: type == 'funeral' }">去世安葬信息</a>
                </li>
                <li v-if="$store.state.hyztData">
                    <!-- <router-link to="/infoMember/spouse">配偶生育信息</router-link> -->
                    <a href="javascript:;" @click="liType('spouse')" :class="{ active: type == 'spouse' }">配偶生育信息</a>
                </li>
                <li v-if="!$store.state.sgztData">
                    <a href="javascript:;" @click="liType('personal')" :class="{ active: type == 'personal' }">联系信息</a>
                </li>
                <li v-if="mtype == 'Edit'">
                    <a href="javascript:;" @click="liType('zlhz')" :class="{ active: type == 'zlhz' }">汇总信息</a>
                </li>
                <li>
                    <router-link to="/mobilelineageChart">返回世系图</router-link>
                </li>
            </ul>
            <div>
                <!-- <router-view /> -->
                <Child :pType="type" @liType="liType"></Child>
            </div>
        </div>
    </div>
</template>

<script>
import Head from "@/components/header.vue";
import Child from "./child.vue";

export default {
    //sgzt
    mounted() {},
    components: {
        Head,
        Child
    },
    watch: {
        "$store.state.infoMemberData": function(val, oldVal) {}
    },
    data() {
        return {
            type: "info",
            mtype:''
        };
    },
    created(){
        this.mtype = sessionStorage.getItem("memberType");
    },
    methods: {
        liType(val) {
            this.type = val;
        }
    }
};
</script>

<style lang="less">
.infoDiv {
    background: #fff;
    // background: #f1f1f4;
    min-height: 100%;
    width: 100%;
    .info {
        margin: 0 auto;
        padding-top: 15px;
        overflow: hidden;
        > ul {
            background: #fff;
            li {
                width: 24%;
                height: 38px;
                line-height: 38px;
                text-align: center;
                display: inline-block;
                a {
                    width: 100%;
                }
                .active {
                    display: block;
                    background: #da5660;
                    color: #fff;
                }
            }
        }

        > div {
            background: #fff;
            .nav {
                height: 40px;
                line-height: 40px;
                padding-left: 15px;
            }

            .con {
                padding-left: 80px;
                padding-top: 20px;
            }
        }
    }
    .el-form-item {
        margin-bottom: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/info/info.vue